import { render, staticRenderFns } from "./Educationalbackground.vue?vue&type=template&id=28719f6a&scoped=true"
import script from "./Educationalbackground.vue?vue&type=script&lang=js"
export * from "./Educationalbackground.vue?vue&type=script&lang=js"
import style0 from "./Educationalbackground.vue?vue&type=style&index=0&id=28719f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28719f6a",
  null
  
)

export default component.exports